import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../api/client';
import type { CustomerListResponse, CustomerSummary } from '../types/site';

const MIN_QUERY_LENGTH = 2;

/**
 * Console global-search backing: the cross-customer command palette in the
 * `SaTopBar` resolves **customers** against the backed `GET /api/v1/site/customers`
 * (`?search=`). User / phone-number matches need a cross-customer user-search
 * endpoint (Identity tools, slice 20) and are intentionally not resolved yet.
 */
export function useCustomerSearch(query: string) {
  const q = query.trim();
  return useQuery<CustomerSummary[]>({
    queryKey: ['site', 'customers', 'search', q],
    enabled: q.length >= MIN_QUERY_LENGTH,
    queryFn: async ({ signal }) => {
      const { data } = await apiClient.get<CustomerListResponse>('/site/customers', {
        params: { search: q, take: 6 },
        signal,
      });
      return data.items;
    },
  });
}

export const SEARCH_MIN_QUERY_LENGTH = MIN_QUERY_LENGTH;
